// Optional prompts for the "Suggest one" button.
//
// Matt: "the default should be just write down whatever word or phrase you
// like... maybe we can have some system or somebody could click for
// suggestions if they want to." So this is a nudge for the person staring at
// an empty box, never the source of the game's words.
//
// Deliberately weighted towards phrases rather than single nouns. A single
// noun ("cat") survives a chain of drawings almost intact, which is the least
// funny outcome; "a cat running a bank" degrades beautifully. The list is
// short on purpose - it exists to unstick somebody, not to be a word deck.
export const SUGGESTIONS = [
  'a haunted piano',
  'penguin detective',
  'the last slice of pizza',
  'a robot learning to swim',
  'grandma at a rock concert',
  'a cat running a bank',
  'sneezing while parachuting',
  'a very small horse',
  'the moon landing, but wet',
  'an octopus doing laundry',
  'a wizard stuck in traffic',
  'two dogs sharing a bicycle',
  'a snowman on holiday',
  'the world championship of yawning',
  'a pirate who is afraid of water',
  'a giraffe in a phone box',
  'toast falling in slow motion',
  'a bear reading the news',
  'synchronised swimming, badly',
  'a haunted vending machine',
  'a duck wearing tiny shoes',
  'an astronaut who forgot something',
  'a dragon with hiccups',
  'the quietest possible party',
  'a spider knitting a jumper',
  'an alligator at the dentist',
  'a lighthouse having a bad day',
  'a hedgehog learning to juggle',
  'somebody losing a hat in the wind',
  'a walrus running for mayor',
];

export const randomSuggestion = (rand = Math.random) => (
  SUGGESTIONS[Math.floor(rand() * SUGGESTIONS.length)]
);
